import { BaseEntity } from ".";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class SkillEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Skill";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: any = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Id
      if (Object.prototype.hasOwnProperty.call(entity.properties, "skill_id")) {
        delete entity.properties.skill_id;
      }
      // - Name
      let name = "(Unknown)";
      const typeEntity = await getCachedTypeEntity(props.skill_id);
      if (typeEntity != null) {
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: typeEntity.props.name,
        };
        name = typeEntity.props.name;
      }
      entity.text = name;
      // - Active Skill Level
      if (props.active_skill_level) {
        entity.properties["active_skill_level"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: props.active_skill_level,
          numberFormat: "##0",
        };
      }
      // - Trained Skill Level
      if (props.trained_skill_level) {
        entity.properties["trained_skill_level"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: props.trained_skill_level,
          numberFormat: "##0",
        };
      }
      // - Skillpoints in Skill
      if (props.skillpoints_in_skill) {
        entity.properties["skillpoints_in_skill"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: props.skillpoints_in_skill,
          numberFormat: "##0",
        };
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
